var _rect, _rect2, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 82,
    viewBox: "0 0 60 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 82,
    fill: "url(#paint0_linear_8044_106085)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.5,
    width: 51,
    height: 73,
    rx: 4,
    stroke: "black",
    strokeDasharray: "4 4"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    clipPath: "url(#clip0_8044_106085)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8059 52.5927L18.9671 55.2315H41.06L39.2212 52.5927H20.8059Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0254 42.5879L19.8455 48.5891H18.2812C17.2328 48.5891 16.3216 48.0131 15.8441 47.0512C15.3666 46.0893 15.4434 44.9884 16.0527 44.1059L26.5777 28.9027V51.228H29.1301V20.6825L13.9779 42.5708C12.817 44.2449 12.6633 46.4241 13.5744 48.2571C14.4856 50.0902 16.2887 51.228 18.2812 51.228H24.0254V42.5879Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.972 42.5879L40.1518 48.5891H41.7162C42.7645 48.5891 43.6757 48.0131 44.1532 47.0512C44.6308 46.0893 44.5539 44.9884 43.9447 44.1059L33.4196 28.9027V51.228H30.8673V20.6825L46.0222 42.5708C47.1831 44.2449 47.3368 46.4241 46.4257 48.2571C45.5145 50.0902 43.7114 51.228 41.7189 51.228H35.9747V42.5879H35.972Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8044_106085",
    x1: 44.5,
    y1: 75.85,
    x2: -9.77951,
    y2: 28.5921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1F57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.340775,
    stopColor: "#654186"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#C393EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793593,
    stopColor: "#B064F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A47DF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8044_106085"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(12 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBack);
export default __webpack_public_path__ + "static/media/card-back.9f2a775258ae518183c309b20528488a.svg";
export { ForwardRef as ReactComponent };